import { LinearProgress } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { usePostHogIdentify } from '../../hooks/usePostHogIdentify';
import { useCheckSessionQuery } from '../../services/api/userService';
import { userLoggedIn, userLoggedOut } from '../../state/reducers/root';

interface SessionManagerProps {
  children: React.ReactElement;
}

const SessionManager: React.FC<SessionManagerProps> = ({ children }) => {
  const dispatch = useDispatch();
  const { data, error, isLoading } = useCheckSessionQuery();

  usePostHogIdentify(data?.user);

  useEffect(() => {
    if (data?.is_valid) {
      dispatch(userLoggedIn(data.user));
    } else if (data && !data.is_valid) {
      dispatch(userLoggedOut());
    } else if (error) {
      dispatch(userLoggedOut());
    }
  }, [dispatch, data, error]);

  if (isLoading || (!data && !error)) {
    return (
      <div>
        <LinearProgress />
      </div>
    );
  }

  return children;
};

export default SessionManager;
